import React, { useEffect, useState } from "react";
// Import icons (you might need to adjust based on the exact icons you want)
import { FaRegUser, FaAsterisk } from "react-icons/fa"; // Example icons

const timelineData = [
  {
    id: 1,
    title: "Program Start",
    description:
      "We kick off the program with a one-hour virtual session four days before the first event. The session's goal is to get acquainted with the team and get a run-through of the program and what to expect. This will include Q&A.",
    dates: "2025 Dates: Apr 29 | Sep 23",
    icon: FaRegUser, // Using FaRegUser as an example for the person icon
    position: "left",
  },
  {
    id: 2,
    title: "Kilimambogo",
    // Use dangerouslySetInnerHTML or a dedicated markdown component
    // for HTML within the description if needed safely.
    // For simplicity here, we embed the span directly.
    description: (
      <>
        Our maiden expedition to Mt.{" "}
        <span className="bg-blue-500 text-white px-1.5 py-0.5 rounded-sm text-sm">
          Kilimambogo
        </span>{" "}
        is a moderate hiking experience meant to spark your interest in outdoor
        fitness life. The mountain is located along the Thika-Garissa highway,
        within the Ol Donyo Sabuk National Park.
      </>
    ),
    dates: "2025 Dates: May 03 | Sep 27",
    icon: FaAsterisk, // Using FaAsterisk for the star icon
    position: "right",
  },
  {
    id: 3,
    title: "Orientation Session", // Assuming a title for the right-side item
    description:
      "After the first hike, we proceed to a two-hour orientation session at The Nairobi Arboretum, where you get to be introduced to the hiking gear you will need along the way. You shall also be taken through the dos and don'ts of hiking—rules and guidelines to keep you safe, alive, and well on the trails.",
    dates: "2025 Dates: May 04 | Sep 28",
    icon: FaAsterisk, // Assuming same icon type for the example
    position: "left", // This card is on the right
  },
  // Add more timeline items here following the same structure
];

const TimelineItem = ({ item }) => {
  const IconComponent = item.icon;
  const isLeft = item.position === "left";

  const [showFull, setShowFull] = useState(false);

  // Helper to get plain text from description (handles string or JSX)
  const getText = (desc) => {
    if (typeof desc === "string") return desc;
    if (React.isValidElement(desc)) {
      // Recursively extract text from children
      const extract = (node) => {
        if (typeof node === "string") return node;
        if (Array.isArray(node)) return node.map(extract).join(" ");
        if (React.isValidElement(node)) return extract(node.props.children);
        return "";
      };
      return extract(desc);
    }
    return "";
  };

  const text = getText(item.description);
  const words = text.split(/\s+/);
  const shouldTruncate = words.length > 20;
  const displayText = showFull || !shouldTruncate
    ? item.description
    : words.slice(0, 20).join(" ") + "...";

  return (
    <div className="relative flex flex-col md:flex-row md:items-start md:justify-between mb-0 lg:mb-12">
      {/* Mobile: stacked | Desktop: node in center */}
      <div className="absolute left-1/2 transform -translate-x-1/2 md:block hidden z-10">
        <div className="bg-orange-500 rounded-full w-10 h-10 flex items-center justify-center text-white">
          <IconComponent size={18} />
        </div>
      </div>

      {/* Timeline Card */}
      <div
        className={`
          w-full md:w-[calc(50%-2.5rem)]
          ${isLeft ? "md:mr-auto md:text-right" : "md:ml-auto md:text-left"}
          mt-0 md:mt-0
        `}
      >
        <div className="bg-white rounded-lg shadow-md p-4 border border-gray-200">
          <h3 className="font-semibold text-gray-800 mb-2 text-xl lg:text-4xl my-5">
            {item.title}
          </h3>
          <p className="text-gray-600 mb-3 text-2xl">
            {showFull || !shouldTruncate ? (
              item.description
            ) : (
              <>
                {words.slice(0, 20).join(" ")}...
                <button
                  className="ml-2 text-blue-600 underline text-base"
                  onClick={() => setShowFull(true)}
                  type="button"
                >
                  View more
                </button>
              </>
            )}
          </p>
          <div className=" bg-gray-500 text-white inline-block px-2 py-2 rounded text-2xl my-5">
            {item.dates}
          </div>
        </div>
      </div>
    </div>
  );
};


const Timeline = ({ adventures }) => {
  const [advList, setAdvList] = useState([]);

  useEffect(() => {
    if (adventures && adventures.length > 0) {
      // Sort adventures by startDate ascending (closest first)
      const sortedAdventures = [...adventures].sort((a, b) => {
        const dateA = new Date(a?.adventure?.startDate);
        const dateB = new Date(b?.adventure?.startDate);
        return dateA - dateB;
      });

      const newAdvList = [];
      let position = "left";

      sortedAdventures.forEach((adventure) => {
        newAdvList.push({
          id: adventure?.adventure?.id,
          title: adventure?.adventure?.name,
          description: adventure?.adventure?.description,
          dates: `Dates: ${adventure?.adventure?.startDate} | ${adventure?.adventure?.endDate}`,
          icon: FaAsterisk,
          position: position,
        });
        position = position === "left" ? "right" : "left";
      });

      setAdvList(newAdvList);
    }
  }, [adventures]);
  

  return (
    <div className="relative w-full mx-auto p-4 md:p-8">
      {/* Timeline Line */}
      <div className="hidden md:block absolute left-1/2 top-0 bottom-0 w-0.5 bg-gray-300 transform -translate-x-1/2"></div>

      {/* Timeline Items */}
      <div className="relative flex flex-col gap-12">
        {advList.length > 0 &&
          advList.map((item, index) => (
            <TimelineItem key={item.id} item={item} />
          ))}
      </div>
    </div>
  );
};


export default Timeline;
